import Phaser from 'phaser';
import { Palette } from '@core/config/constants';
import { AUDIO_REGISTRY_KEY } from '@core/scenes/BaseScene';
import type { AudioService } from '@core/services/AudioService';

export interface TextButtonOptions {
  x: number;
  y: number;
  label: string;
  width?: number;
  height?: number;
  color?: number;
  onClick: () => void;
}

const DEFAULT_WIDTH = 320;
const DEFAULT_HEIGHT = 84;
const HOVER_SCALE = 1.06;

/**
 * Boton reutilizable basado en un Container de Phaser. Encapsula fondo, texto e
 * interaccion para no repetir codigo de botones en cada escena.
 */
export class TextButton extends Phaser.GameObjects.Container {
  public constructor(scene: Phaser.Scene, options: TextButtonOptions) {
    super(scene, options.x, options.y);

    const width = options.width ?? DEFAULT_WIDTH;
    const height = options.height ?? DEFAULT_HEIGHT;
    const color = options.color ?? Palette.primary;

    const background = scene.add.graphics();
    background.fillStyle(color, 1);
    background.fillRoundedRect(-width / 2, -height / 2, width, height, 18);

    const label = scene.add
      .text(0, 0, options.label, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '30px',
        color: Palette.textLight,
        align: 'center',
      })
      .setOrigin(0.5);

    this.add([background, label]);
    this.setSize(width, height);
    this.setInteractive({ useHandCursor: true });

    this.on(Phaser.Input.Events.POINTER_OVER, () => this.setScale(HOVER_SCALE));
    this.on(Phaser.Input.Events.POINTER_OUT, () => this.setScale(1));
    this.on(Phaser.Input.Events.POINTER_DOWN, () => this.setScale(1));
    this.on(Phaser.Input.Events.POINTER_UP, () => {
      this.setScale(HOVER_SCALE);
      const audio = scene.registry.get(AUDIO_REGISTRY_KEY) as AudioService | undefined;
      audio?.playClick();
      options.onClick();
    });

    scene.add.existing(this);
  }
}
